export default __webpack_public_path__ + "static/media/colonialSlide2.42a7d444.jpg";